/* eslint-disable no-shadow */
/* eslint-disable no-return-assign */
import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import valueMapsService from 'src/services/valueMapsService'
import ValueMapDetailPage from 'src/pages/InsigthPage/ValueMap/ValueMapDetailPage'
import { transparentize, CHART_COLORS } from 'src/utils/chartsUtils'
import AddAlert from '@material-ui/icons/AddAlert'
import Snackbar from 'src/components/sharedComponents/Snackbar/Snackbar'
import swal from 'sweetalert'
import { swalMessages } from 'src/constants'
import modeloRegresion from 'src/utils/modeloRegresion'
import puntoPendiente from 'src/utils/puntoPendiente'

const initialSatate = {
  linea: null,
  imagen: null,
  empresa: null,
  version: null,
  categoria: null,
  subcategoria: null,
  segmento: null,
  subsegmento: null,
  precio: null,
  unidades: null,
  promocion: null,
  atributos: [{ valor: 0, atributo: '' }],
  caracteristicas: [],
}

const initialSatate2 = {
  y: null,
  m: null,
  d: null,
  titulo: 'null',
  descripcion: 'null',
  categoria: null,
  subcategoria: null,
  segmento: null,
  subsegmento: null,
  foto: [],
  ultimo: 0,
  result: 0,
  pivote: 1,
  prev_modelo: 1,
  unidades_diferencia: 0,
}

const initialSatate3 = { peso: 0, atributo: '' }

const calculateMarketShare = (value) => {
  if (!value) return 0
  const result = value.reduce(
    (total, current) => total + +current?.unidades || 0,
    0,
  )
  return result || 0
}

const ValueMapsContainer = () => {
  const [save, setSave] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [update, setUpdate] = useState(false)
  const [stateEdit, setStateEdit] = useState(false)

  const [vehicles, setVehicles] = useState([])
  const [features, setFeatures] = useState([])
  const [reference, setReference] = useState([])
  const [totalMapsValue, setTotalMapsValue] = useState([])
  const [vehiclesBySegment, setVehicleBySegment] = useState([])

  const [mapValue, setMapValue] = useState(initialSatate2)
  const [newVehicle, setNewVehicle] = useState(initialSatate)
  const [attributes, setAttributes] = useState([initialSatate3])

  const [open, setOpen] = useState({ open: false, isEdit: false })

  const location = useLocation().state

  const timerToClearSomewhere = useRef(null)
  const date = new Date()
  const rMAX = 40
  const rMIN = 8
  const fnModelo = modeloRegresion(reference || [])

  // defino mapa de valor cuando llega
  const getValueMap = async () => {
    const response = await valueMapsService.getValueMap(location)
    if (response) {
      const index = response.findIndex((value) => +value.ultimo === 1)
      setMapValue({
        ...(response[index] || initialSatate2),
        result: +calculateMarketShare(response[index]?.foto || []),
      })
      setReference(response[index]?.foto || [])
      setTotalMapsValue(response || [])
    }
  }

  const reloadVehiclesBySegmentation = async () => {
    setLoading(true)
    const response = await valueMapsService.getVehiclesBySegmentation(location)
    setVehicleBySegment(response)
    setLoading(false)
  }

  const reloadVehicles = async () => {
    const response = await valueMapsService.getVehicles(location)
    if (response) {
      setVehicles(response)
    }
  }

  const reloadAttributesAndFeatures = async () => {
    const [attribute, feature] = await Promise.all([
      valueMapsService.getAttributes(location),
      valueMapsService.getFeatures(),
    ])
    setFeatures(feature)
    setAttributes(attribute.length === 0 ? [initialSatate3] : attribute)
  }

  useEffect(() => {
    let ignore = false
    if (!ignore) {
      getValueMap()
      reloadVehicles()
      reloadAttributesAndFeatures()
      reloadVehiclesBySegmentation()
    }
    return () => {
      ignore = true
    }
  }, [])

  const handleSaveValueMap = async () => {
    const response = await valueMapsService.createValueMap({
      ...mapValue,
      categoria: location.category,
      subcategoria: location.subCategory,
      segmento: location.segment,
      subsegmento: location.subSegment,
      territorio_id: location.id,
      d: date.getDate(),
    })
    if (response.success > 0) {
      setSave(false)
      setUpdate(true)
      getValueMap() // recargo mapa de valor cuando cargo
    }
  }

  const onChangeMapValue = (value) => {
    setMapValue({ ...mapValue, ...value })
  }

  const handleOpenModalSave = () => {
    setSave(true)
    setMapValue((prevState) => ({
      ...prevState,
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
    }))
  }

  const handleClose = () => {
    setSave(false)
  }

  const calculatePerceivedValue = (value) => {
    if (!value) return 0
    let sum = 0
    value.forEach((element) => {
      const searchAtr = attributes.findIndex(
        (item) => (item?.atributo || 0) === (element?.atributo || 0),
      )
      if (searchAtr !== -1) {
        sum += (+element?.valor || 0) * +attributes[searchAtr]?.peso || 0
      }
    })
    return sum
  }

  const handleAddMapValue = (value) => {
    const index = mapValue.foto.findIndex((foto) => foto.id === value.id)
    // calculo atributos
    const vneto = (+value.precio || 0) - (+value.promocion || 0)
    if (index === -1) {
      mapValue.foto.push({
        ...value,
        vpercibido: calculatePerceivedValue(value.atributos) || 0,
        vneto,
      })
    } else {
      Object.assign(mapValue.foto[index], { ...value, vneto })
    }

    const indexReference = reference.findIndex((refe) => refe.id === value.id)
    if (indexReference === -1) {
      reference.push({
        ...value,
        vpercibido: calculatePerceivedValue(value.atributos),
        vneto,
      })
    }

    mapValue.foto.sort((a, b) => (+a.unidades > +b.unidades ? 1 : -1))

    setMapValue((prev) => ({
      ...prev,
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      titulo: '',
      descripcion: '',
      result: +calculateMarketShare(mapValue.foto || 0),
      segmento: location.segment,
      subsegmento: location.subSegment,
      foto: [...mapValue.foto],
    }))

    setUpdate(true)
  }

  const handleSelectMapValue = (value) => {
    setStateEdit(value?.ultimo !== '1')
    setMapValue({
      ...initialSatate2,
      ...value,
      result: +calculateMarketShare(value?.foto || []),
    })
  }

  const handleAddAttribute = () => {
    setAttributes((prev) => [...prev, initialSatate3])
  }

  const handleDeleteAttribute = async (index) => {
    const clonedData2 = attributes
    const clonedData = newVehicle
    await valueMapsService.deleteAttribute(clonedData2[index].id)
    if (index !== 0) {
      clonedData2.splice(index, 1)
      clonedData.atributos.splice(index, 1)
    } else {
      clonedData2[index] = initialSatate3
      clonedData.atributos[index] = {}
    }
    setAttributes(() => [...clonedData2])
  }

  const handleCreateAttribute = async (index) => {
    await valueMapsService.createAttribute({
      ...attributes[index],
      categoria: location.category,
      subcategoria: location.subCategory,
      segmento: location.segment,
      subsegmento: location.subSegment,
    })
  }

  const handleDeleteValueMap = async () => {
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        valueMapsService
          .deleteValueMap(mapValue.id)
          .then((response) => {
            if (response.id === 0) {
              swal(swalMessages.GENERAL_ERROR)
            }
            getValueMap()
          })
          .catch((error) => {
            console.log(error)
          })
      }
    })
  }

  const handleEditAttribute = async (index) => {
    await valueMapsService.updateAttribute({
      ...attributes[index],
    })
  }

  const onChangeAddPram = (param, index, row, value, type) => {
    const newValue = value.replace(',', '.')
    Object.assign(newVehicle[param][index], {
      [type]: newValue,
    })
    setNewVehicle((prev) => ({
      ...prev,
      ...newVehicle,
    }))
    // actulizo característica spor vehiculo
    if (param !== 'caracteristicas') {
      const clonedData2 = attributes
      clonedData2[index] = { ...clonedData2[index], [type]: newValue }
      setAttributes(() => [...clonedData2])
    }
  }

  const onChangeAttribute = (type, index, value) => {
    setAttributes((prev) => {
      const clonedData2 = [...prev]
      clonedData2[index] = { ...clonedData2[index], [type]: value }
      return [...clonedData2]
    })
    newVehicle.atributos[index] = {
      ...newVehicle.atributos[index],
      [type]: value,
    }
  }

  const handleSelectForm = (param) => {
    setNewVehicle((prev) => ({
      ...prev,
      ...param,
    }))
  }

  const handleSaveImage = async (param) => {
    const response = await valueMapsService.saveImage(param)
    setNewVehicle((prev) => ({
      ...prev,
      imagen: response,
    }))
  }

  const handleOpenModal = ({ open, isEdit, index }) => {
    const array = isEdit ? vehicles[index] : newVehicle
    setOpen({ open, isEdit })
    setNewVehicle({ ...array })
    reloadVehiclesBySegmentation()
    reloadAttributesAndFeatures()
    if (!isEdit) {
      setNewVehicle({
        ...initialSatate,
        atributos: attributes,
        caracteristicas: features,
      })
    }
  }

  const handleCreateCard = async () => {
    const { isEdit } = open
    const searhIndex = mapValue.foto.findIndex(
      (foto) => foto.id === newVehicle.id,
    )
    if (!isEdit) {
      const response = await valueMapsService.createVehicle({
        ...newVehicle,
        ...location,
      })

      if (response) {
        setOpen({ open: false, isEdit: false })
        reloadVehicles()
        setUpdate(true)
        setNewVehicle(initialSatate)
      }
      if (!response) {
        setError(true)
        // setUpdate(true)
      }
    } else {
      const editResponse = await valueMapsService.updateVehicle({
        ...newVehicle,
        territorio_id: location.id,
      })
      if (editResponse) {
        Object.assign(mapValue, {
          prev_modelo: mapValue.foto[mapValue.foto.length - 1]?.modelo || 1,
        })
        if (searhIndex !== -1) {
          mapValue.foto[searhIndex] = {
            ...mapValue.foto[searhIndex],
            ...newVehicle,
            vpercibido: calculatePerceivedValue(newVehicle.atributos),
            vneto: (+newVehicle.precio || 0) - (+newVehicle.promocion || 0),
          }
        }

        setMapValue((prev) => ({
          ...prev,
          result: +calculateMarketShare(mapValue.foto || []),
          foto: [...mapValue.foto],
          titulo: '',
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
        }))
        setUpdate(true)
        reloadVehicles()
      }
      setOpen({ open: false, isEdit: false })
    }
  }

  const handleDeleteCard = async () => {
    const isDelete = await valueMapsService.deleteVehicle(newVehicle.id)
    if (isDelete) {
      setNewVehicle(initialSatate)
      reloadVehicles()
      setOpen({ open: false, isEdit: false })
    }
  }

  const dataLineSetGenerator = (lineType, array) => ({
    type: 'line',
    label: 'Linea mes',
    display: false,
    backgroundColor: transparentize(
      lineType == 'unidades' ? CHART_COLORS.green : CHART_COLORS.drab,
      1,
    ),
    borderColor:
      lineType === 'unidades' ? CHART_COLORS.green : CHART_COLORS.drab,
    order: 0,
    data: puntoPendiente(array.foto),
    datalabels: {
      labels: {
        index: {
          align: 'end',
          anchor: 'end',
          color(ctx) {
            return ctx.dataset.backgroundColor
          },
          font: { size: 10 },
          formatter() {
            return ''
          },
          offset: 2,
          opacity(ctx) {
            return ctx.active ? 1 : 0.5
          },
        },
      },
    },
  })

  const handleRemoveCard = (card) => {
    mapValue.foto.splice(card.index, 1)
    mapValue.foto.sort((a, b) => (+a.unidades > +b.unidades ? 1 : -1))
    setMapValue((prev) => ({
      ...prev,
      pivote: 1,
      prev_modelo: 1,
      result_out: 0,
      foto: [...mapValue.foto],
      result: +calculateMarketShare(mapValue.foto || []),
    }))
    reference.splice(card.index, 1)
  }

  const dataSetGenerator = (array, param) => {
    let dataGraph = {}
    dataGraph = {
      labels: array.foto.map((vp) => vp.vpercibido),
      datasets: array.foto.reduce((r, a) => {
        r.push({
          label: a.linea || '',
          data: [
            {
              x: +a.vpercibido || 0, // percibido
              y: +a.vneto || 0, // precio neto
              r:
                (rMAX - rMIN) *
                  (1 -
                    (array.foto[array.foto.length - 1][param] - a[param]) /
                      (array.foto[array.foto.length - 1][param] -
                        array.foto[0][param])) +
                rMIN,
              // radio
            },
          ],
          order: 0,
          backgroundColor: transparentize(
            Object.values(CHART_COLORS)[
              Object.keys(CHART_COLORS).findIndex(
                (itemColor) => itemColor === a?.empresa?.toLowerCase(),
              )
            ] || Object.values(CHART_COLORS)[8],
            0.5,
          ),
          datalabels: {
            labels: {
              index: {
                align: 'start',
                anchor: 'end',
                color(ctx) {
                  return transparentize(ctx.dataset.backgroundColor, 0)
                },
                font: { size: 12 },
                formatter() {
                  return `${a.linea}  ${a[param]}`
                },
                offset: 2,
              },
            },
          },
        })
        return r
      }, []),
      plugins: {
        legend: false,
      },
    }
    dataGraph.datasets.push(dataLineSetGenerator(param, array))
    return dataGraph
  }

  useEffect(() => {
    if (update || error) {
      timerToClearSomewhere.current = setInterval(() => {
        setUpdate(false)
        setError(false)
      }, 2000)
    }
    return () => {
      clearInterval(timerToClearSomewhere.current)
    }
  }, [update, error])

  const fnUpUpdateMap = (paramUpdate, marketShare, vehicleSegmnet) => {
    const indexMapValue = mapValue.foto.findIndex(
      (item) =>
        item?.linea === vehicleSegmnet?.LINEA &&
        item.empresa === vehicleSegmnet.EMPRESA,
    )
    if (indexMapValue !== -1) {
      setMapValue((prev) => ({
        ...prev,
        foto: [
          ...prev.foto.slice(0, indexMapValue),
          {
            ...prev.foto[indexMapValue],
            ...paramUpdate,
            new_modelo: 0,
            pivote: 0,
            result_out: 0,
            unidades_diferencia: 0,
            vpercibido: calculatePerceivedValue(paramUpdate.atributos),
            vneto:
              (+vehicleSegmnet.PRECIO || 0) - (+vehicleSegmnet.PROMOCION || 0),
          },
          ...prev.foto.slice(indexMapValue + 1),
        ],
        pivote: 0,
        prev_modelo: 0,
        result_out: 0,
        result: +calculateMarketShare(marketShare || []),
        titulo: '',
        y: 0,
        m: 0,
      }))
    }
  }

  const handleUpdateMapValue = (isUpdate = false) => {
    const message = isUpdate
      ? swalMessages.UPDATE_CONFIRM
      : swalMessages.UPDATE_CONFIRM_VALUE_MAP
    swal(message).then((accepUpdate) => {
      if (accepUpdate) {
        const marketShare = []
        vehiclesBySegment.forEach(async (vehicleSegmnet) => {
          const indexVehicles = vehicles.findIndex(
            ({ linea, empresa }) =>
              linea === vehicleSegmnet?.LINEA &&
              empresa === vehicleSegmnet.EMPRESA,
          )
          if (indexVehicles !== -1) {
            const paramUpdate = {
              ...vehicles[indexVehicles],
              atributos: !isUpdate
                ? vehicles[indexVehicles].atributos
                : attributes,
              precio: vehicleSegmnet.PRECIO,
              unidades: vehicleSegmnet.UNIDADES,
              proyectado: vehicleSegmnet.PROYECCION,
              promocion: vehicleSegmnet.PROMOCION,
            }
            marketShare.push(paramUpdate)
            setVehicles(() => [
              ...vehicles.slice(0, indexVehicles),
              (vehicles[indexVehicles] = {
                ...vehicles[indexVehicles],
                ...paramUpdate,
              }),
              ...vehicles.slice(indexVehicles + 1),
            ])
            await valueMapsService.updateVehicle(paramUpdate)
            fnUpUpdateMap(paramUpdate, marketShare, vehicleSegmnet)
          }
        })
        setStateEdit(false)
        setUpdate(true)
      }
    })
  }

  useEffect(() => {
    const searhIndex = mapValue.foto.findIndex(
      (foto) => foto.id === newVehicle.id,
    )
    mapValue.foto.forEach((element) => {
      Object.assign(element, {
        modelo: fnModelo(+element.vpercibido, +element.vneto),
      })
    })

    setMapValue((prev) => ({
      ...prev,
      result_out:
        searhIndex !== -1
          ? mapValue.result - +mapValue.foto[searhIndex].unidades
          : 0,
      pivote:
        searhIndex !== -1
          ? +mapValue.foto[searhIndex]?.modelo / +mapValue.prev_modelo
          : 1,
    }))

    if (searhIndex !== -1) {
      // asigno al editdo el nuevo modelo o numero de unidades
      mapValue.foto[searhIndex] = {
        ...mapValue.foto[searhIndex],
        new_modelo:
          +mapValue.foto[searhIndex].unidades *
          (+mapValue.foto[searhIndex]?.modelo / +mapValue.prev_modelo),
      }
      Object.assign(mapValue, {
        unidades_diferencia:
          +mapValue.foto[searhIndex].unidades -
          +mapValue.foto[searhIndex].unidades *
            (+mapValue.foto[searhIndex]?.modelo / +mapValue.prev_modelo),
      })
      // recorro el modelo para asignar al resto de los elementos el nuevo modelo
      mapValue.foto.forEach((element, index) => {
        if (index !== searhIndex) {
          mapValue.foto[index] = {
            ...mapValue.foto[index],
            new_modelo:
              (+element.unidades / +mapValue.result_out) *
                mapValue.unidades_diferencia +
              +element.unidades,
          }
        }
      })
    }
    // setUpdate(false)
  }, [update])

  return (
    <>
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="danger"
        icon={AddAlert}
        message="Se ha producido un error al guardar, verifica que todos los campos esten completos"
        open={error} // true o false
      />
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="success"
        icon={AddAlert}
        message="Mapa de Valor actualizado correctamente"
        open={update} // true o false
      />
      <ValueMapDetailPage
        save={save}
        open={open}
        loading={loading}
        mapValue={mapValue}
        vehicles={vehicles}
        stateEdit={stateEdit}
        attributes={attributes}
        newVehicle={newVehicle}
        handleClose={handleClose}
        totalMapsValue={totalMapsValue}
        onChangeAddPram={onChangeAddPram}
        handleSaveImage={handleSaveImage}
        handleOpenModal={handleOpenModal}
        addToMapValue={handleAddMapValue}
        dataSetGenerator={dataSetGenerator}
        handleDeleteCard={handleDeleteCard}
        handleCreateCard={handleCreateCard}
        handleSelectForm={handleSelectForm}
        handleRemoveCard={handleRemoveCard}
        onChangeMapValue={onChangeMapValue}
        vehiclesBySegment={vehiclesBySegment}
        onChangeAttribute={onChangeAttribute}
        handleSaveValueMap={handleSaveValueMap}
        handleAddAttribute={handleAddAttribute}
        handleEditAttribute={handleEditAttribute}
        handleOpenModalSave={handleOpenModalSave}
        handleSelectMapValue={handleSelectMapValue}
        handleDeleteValueMap={handleDeleteValueMap}
        handleUpdateMapValue={handleUpdateMapValue}
        handleDeleteAttribute={handleDeleteAttribute}
        handleCreateAttribute={handleCreateAttribute}
      />
    </>
  )
}

export default ValueMapsContainer
